import { useMemo } from 'react';
import useStore from '@components/MainStage/store';
import {
  InitiativesSubLayerTypes,
  LogicalSubLayerTypes,
  PhysicalSubLayerTypes,
} from '@constants/canvas/layers';

const initiativeConnectLayers = [
  LogicalSubLayerTypes.Services,
  PhysicalSubLayerTypes.Capabilities,
  PhysicalSubLayerTypes.Functions,
];

const useIsInitiativeRelation = () => {
  const { getActiveEdge, nodes } = useStore();
  const activeEdge = getActiveEdge();

  const isInitiativeRelation = useMemo(() => {
    if (!activeEdge?.data?.dto) return false;

    const { parent_id, child_id } = activeEdge.data.dto;

    const parent = nodes.find((node) => node.id === parent_id);
    const child = nodes.find((node) => node.id === child_id);

    if (parent && child) {
      const isParentLogicOrPhysical = initiativeConnectLayers.includes(
        parent.parentNode as LogicalSubLayerTypes,
      );

      const isChildInitiative =
        child.parentNode === InitiativesSubLayerTypes.ChangeInitiatives;

      return isParentLogicOrPhysical && isChildInitiative;
    }

    return false;
  }, [activeEdge?.id, activeEdge]);

  return { isInitiativeRelation };
};

export default useIsInitiativeRelation;
